<template>
  <v-container fluid>
    <notifications group="actions"></notifications>
    <h2 class="display-1 font-weight-light">Settings</h2>
    <v-flex>
      <edit-plans :user-data="userData"></edit-plans>
      <edit-login-credentials :user-data="userData"></edit-login-credentials>
      <edit-settings :user-data="userData" :linkedinUrls="linkedinUrls" @reload="reloadHandler"></edit-settings>
      <edit-list-users
        :user-data="userData"
        :users-list="usersList"
        @userAdded="loadClientUsers()"
        @userStatusChanged="changeUserStatus"
        v-if="userData.role !== 'user'">

      </edit-list-users>

      <!--Todo-->
      <edit-notifications
        :user-data="userData"
        :users-list="usersList"
        @reload="reloadHandler"
      ></edit-notifications>
    </v-flex>
  </v-container>
</template>

<script>
  import api from '@/api/index';

  import EditPlans from "../../components/Sections/editPlans";
  import EditLoginCredentials from "../../components/Sections/editLoginCredentials";
  import EditSettings from "../../components/Sections/editSettings";
  import EditListUsers from "../../components/Sections/editListUsers";
  import EditNotifications from "../../components/Sections/editNotifications";


  export default {
    name: "settingsUser",
    components: {EditNotifications, EditListUsers, EditSettings, EditLoginCredentials, EditPlans},
    computed: {
      userData() {
        return this.$store.getters.getUserFromToken;
      }
    },
    data: () => ({
      usersList: [],
      linkedinUrls: []
    }),
    methods: {
      loadCompanyLinkedinUrls() {
        let clientId = this.userData.clientId;
        api.clients.getCompanyLinkedinUrls({clientId})
          .then(response => {
            this.linkedinUrls = response.data.data.linkedinUrls;
          })
          .catch(error => {
            console.log(error);
          })
      },
      loadClientUsers() {
        let clientId = this.userData.clientId;
        api.clients.getUsersOfAccount({clientId})
          .then(response => {
            this.usersList = response.data.data.users.map(e => ({status: 'active', ...e}));
          })
          .catch(error => {
            console.log(error);
          })
      },
      reloadHandler() {
        this.loadCompanyLinkedinUrls();
        console.log(this.userData)
        if (this.userData.role !== 'user') {
          this.loadClientUsers();
        } else {
          this.usersList = [this.userData]
        }
      },
      changeUserStatus(user) {
        let clientId = this.userData.clientId;
        let userId = user._id;
        let status = user.status;
        let email = user.email;

        this.$store.dispatch('updateUserStatus', {clientId, userId, status, email})
          .then(() => {
            this.loadClientUsers()
          })
      }
    },
    mounted() {
      this.reloadHandler();
    }
  }
</script>

<style scoped>
  td:nth-of-type(1) {
    min-width: 50% !important;
    width: 50% !important;
    max-width: 50% !important;
    font-weight: bold;
  }

  td:nth-of-type(2) {
    min-width: 50% !important;
    width: 50% !important;
    max-width: 50% !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/settings/IcevergSettings.vue